 import { Link, useLocation } from "react-router-dom";
import { Home, User, Shield, LogOut } from "lucide-react";
 import { cn } from "@/lib/utils";
 import { useAuth } from "@/contexts/AuthContext";
 import { useIsAdmin } from "@/hooks/useIsAdmin";
import { supabase } from "@/integrations/supabase/client";
 
 export function FloatingNav() {
   const location = useLocation();
   const { user } = useAuth();
   const { isAdmin } = useIsAdmin();
 
  const isOnAccountPage = location.pathname === "/account";

   const isActive = (path: string) => {
     if (path === "/") {
       return location.pathname === "/" && !location.hash;
     }
     return location.pathname === path || location.pathname.startsWith(path + "/");
   };
 
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

    return (
      <nav className="w-full py-6">
        <div className="container flex items-center justify-center gap-4 px-4">
        {/* Home button */}
           <Link
             to="/"
             className={cn(
               "p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110",
                "backdrop-blur-sm border",
               isActive("/")
                  ? "bg-brand-pink border-brand-pink/50"
                  : "bg-card/90 border-border/50 text-brand-pink hover:bg-brand-pink/20"
             )}
             aria-label="Home"
           >
               <Home className={cn("h-5 w-5", isActive("/") ? "text-white" : "text-brand-pink")} />
           </Link>

           
        {/* Admin button - only for admins */}
        {isAdmin && (
             <Link
               to="/admin"
               className={cn(
                 "p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110",
                  "backdrop-blur-sm border",
                 isActive("/admin")
                    ? "bg-brand-purple border-brand-purple/50"
                    : "bg-card/90 border-border/50 hover:bg-brand-purple/20"
               )}
               aria-label="Admin"
             >
               <Shield className={cn("h-5 w-5", isActive("/admin") ? "text-white" : "text-brand-purple")} />
             </Link>
        )}
 
        {/* Account or Sign Out button */}
        {isOnAccountPage && user ? (
          <button
            onClick={handleSignOut}
            className={cn(
              "p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110",
               "bg-card/90 backdrop-blur-sm border border-border/50",
               "hover:bg-destructive/20 hover:border-destructive/50"
            )}
            aria-label="Sign Out"
          >
             <LogOut className="h-5 w-5 text-destructive" />
          </button>
        ) : (
          <Link
            to={user ? "/account" : "/login"}
            className={cn(
              "p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110",
               "backdrop-blur-sm border",
               "bg-card/90 border-border/50 hover:bg-brand-teal/20"
            )}
            aria-label={user ? "My Account" : "Login"}
          >
             <User className="h-5 w-5 text-brand-teal" />
          </Link>
        )}
        </div>
      </nav>
    );
  }